import React, { Fragment, useState } from 'react';
import { Container } from 'react-bootstrap';
import HeaderLogged from '../../../../../components/header_logged'
import Footer from '../../../../../components/footer'
import Head from '../../../../../components/head';
import FormCad from '../../../../../components/auth/institucional/secretaria/form_cad'


function CadastrarSecretariaScreen() {

    return (
        <Fragment>
            <Head titulo="Cadastrar Secretaria Municipal" />
            <HeaderLogged />
            <Container>
               <FormCad />
            </Container>
            <Footer />
        </Fragment>
    );
}

export default CadastrarSecretariaScreen;